import React from "react";
import { getWorkingDaysInMonth } from "../../utils/italianHolidays";
import {
  TIMESHEET_STATUS_LABELS,
  TIMESHEET_STATUS_COLORS,
} from "../../constants/timesheetStatus";

export default function TimesheetSummary({
  year,
  month,
  entries,
  rate,
  compensationType,
  status,
  darkMode = false,
}) {
  const workingDays = getWorkingDaysInMonth(year, month);

  const fullDays = (entries || []).filter((e) => e.value === 1).length;
  const halfDays = (entries || []).filter((e) => e.value === 0.5).length;
  const totalDays = fullDays + halfDays * 0.5;

  const totalAmount = (compensationType === "daily" || compensationType === "hourly")
    ? totalDays * (rate || 0)
    : compensationType === "fixed"
      ? rate || 0
      : 0;

  const statusColors = TIMESHEET_STATUS_COLORS[status] || TIMESHEET_STATUS_COLORS.draft;
  const statusLabel = TIMESHEET_STATUS_LABELS[status] || status;

  const formatAmount = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    }).format(amount);

  return (
    <div
      className={`rounded-xl border p-4 ${
        darkMode ? "border-neutral-800 bg-neutral-900" : "border-neutral-200 bg-white"
      }`}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className={`text-sm font-semibold ${darkMode ? "text-white" : "text-neutral-900"}`}>
          Riepilogo
        </h3>
        <span
          className={`text-xs font-medium px-2 py-1 rounded-full ${
            darkMode ? statusColors.dark : statusColors.light
          }`}
        >
          {statusLabel}
        </span>
      </div>

      <div className="space-y-3">
        <div className="flex justify-between">
          <span className={`text-xs ${darkMode ? "text-neutral-500" : "text-neutral-500"}`}>
            Giorni lavorativi nel mese
          </span>
          <span className={`text-sm font-medium ${darkMode ? "text-white" : "text-neutral-900"}`}>
            {workingDays}
          </span>
        </div>

        <div className="flex justify-between">
          <span className={`text-xs ${darkMode ? "text-neutral-500" : "text-neutral-500"}`}>
            Giornate intere
          </span>
          <span className={`text-sm font-medium ${darkMode ? "text-white" : "text-neutral-900"}`}>
            {fullDays}
          </span>
        </div>

        <div className="flex justify-between">
          <span className={`text-xs ${darkMode ? "text-neutral-500" : "text-neutral-500"}`}>
            Mezze giornate
          </span>
          <span className={`text-sm font-medium ${darkMode ? "text-white" : "text-neutral-900"}`}>
            {halfDays}
          </span>
        </div>

        <div className={`border-t pt-3 ${darkMode ? "border-neutral-800" : "border-neutral-100"}`}>
          <div className="flex justify-between">
            <span className={`text-xs font-medium ${darkMode ? "text-neutral-400" : "text-neutral-600"}`}>
              Totale giorni
            </span>
            <span className={`text-sm font-bold ${darkMode ? "text-white" : "text-neutral-900"}`}>
              {totalDays}
            </span>
          </div>
        </div>

        {rate > 0 && compensationType !== "project" && (
          <>
            <div className="flex justify-between">
              <span className={`text-xs ${darkMode ? "text-neutral-500" : "text-neutral-500"}`}>
                Tariffa
              </span>
              <span className={`text-sm font-medium ${darkMode ? "text-white" : "text-neutral-900"}`}>
                {formatAmount(rate)}
                {compensationType === "daily" ? "/gg" : compensationType === "hourly" ? "/h" : "/mese"}
              </span>
            </div>

            <div className={`border-t pt-3 ${darkMode ? "border-neutral-800" : "border-neutral-100"}`}>
              <div className="flex justify-between">
                <span className={`text-sm font-semibold ${darkMode ? "text-neutral-300" : "text-neutral-700"}`}>
                  Importo totale
                </span>
                <span className={`text-base font-bold ${darkMode ? "text-emerald-400" : "text-emerald-600"}`}>
                  {formatAmount(totalAmount)}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
